"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var shadows = {
    boxShadow: {
        card: "0 20px 50px 0 rgba(0, 0, 0, 0.1)",
        navbar: "rgba(0, 0, 0, 0.05) 0px 1px 0px 0px, rgba(0, 0, 0, 0.06) 0px 3px 6px 0px",
        button: "0 2px 4px 0 rgba(0, 0, 0, 0.05)",
        buttonPrimary: "inset 0 0.5px 0 0 rgba(255, 255, 255, 0.5)",
        input: "inset 0 1px 2px 0 rgba(0, 0, 0, 0.14)",
        select: "0 4px 10px 0 rgba(21, 19, 56, 0.07)",
        downloadIcon: "inset 0px 1.5px 0px 0px rgb(255, 255, 255), 0px 2px 4px 0px rgba(0, 0, 0, 0.06)"
    },
    textShadow: {}
};
exports.default = shadows;
//# sourceMappingURL=shadows.js.map